import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";

import AxiosProvider from "../providers/AxiosProvider";

import Menu from "../components/Menu";
import Login from "../pages/Login";
import RedefinirSenha from "../pages/RedefinirSenha";
import Dashboard from "../pages/Dashboard";
import { useAuth } from "../auth/ProvideAuth";
import Relatorios from "../pages/Relatorios";
import Empresas from "../pages/Empresas";
import VisualizarRelatorio from "../pages/VisualizarRelatorio";
import VisualizarRelatorioToken from "../pages/VisualizarRelatorio/index_token";
import SingUp from "../pages/SingUp";
import Questionnaires from "../pages/Questionnaires";
import Plano from "./../pages/Plano";
import DashboardResumido from "../pages/DashboardResumido";
import Cadastro from "../pages/Empresas/Cadastro";
import DadosInternos from "../pages/DadosInternos";
import RelatoriosDeConsulta from "../pages/RelatoriosDeConsulta";
import ImportacaoDados from "../pages/ImportacaoDados";

const RouterNeocredit = () => {
  const auth = useAuth();
  return (
    <Router>
      <AxiosProvider>
        <Menu pagina="dasboard" />
        <Switch>
          <Route path="/login">
            {auth.user != null ? <Redirect to="/" /> : <Login />}
          </Route>
          
          <Route path="/singup">
            {auth.user != null ? <Redirect to="/" /> : <SingUp />}
          </Route>
          <Route path="/questionnaires">
            {auth.user != null ? <Redirect to="/" /> : <Questionnaires />}
          </Route>
          <Route path="/redefinirSenha">
            <RedefinirSenha />
          </Route>
          <Route exact path="/">
            {auth.user == null ? <Redirect to="/login" /> : <Dashboard />}
          </Route>
          <Route exact path="/historico">
            {auth.user == null ? (
              <Redirect to="/login" />
            ) : (
              <DashboardResumido />
            )}
          </Route>
          <Route exact path="/dadosInternos">
            {auth.user == null ? <Redirect to="/login" /> : <DadosInternos />}
          </Route>
          <Route exact path="/relatorios">
            {auth.user == null ? <Redirect to="/login" /> : <Relatorios />}
          </Route>
          <Route exact path="/relatoriodeconsulta">
            {auth.user == null ? <Redirect to="/login" /> : <RelatoriosDeConsulta />}
          </Route>
          <Route path="/relatorios/:id">
            {auth.user == null ? (
              <Redirect
                push
                to={{
                  pathname: "/login",
                  state: { redirect_rel: true },
                }}
              />
            ) : (
              <VisualizarRelatorio />
            )}
          </Route>
          <Route path="/relatorio/:token">
            <VisualizarRelatorioToken />
          </Route>
          <Route path="/plano">
            {auth.user == null ? <Redirect to="/login" /> : <Plano />}
          </Route>
          <Route exact path="/empresas">
            {auth.user == null ? <Redirect to="/login" /> : <Empresas />}
          </Route>
          <Route exact path="/empresas/cadastro">
            {auth.user == null ? <Redirect to="/login" /> : <Cadastro />}
          </Route>
          <Route exact path="/empresas/cadastro/:id">
            {auth.user == null ? <Redirect to="/login" /> : <Cadastro />}
          </Route> 
          <Route exact path="/importacao">
            {auth.user == null ? <Redirect to="/login" /> : <ImportacaoDados />}
          </Route>
        </Switch>
      </AxiosProvider>
    </Router>
  );
};

export default RouterNeocredit;
